import { render } from "./CompanyNav.vue?vue&type=template&id=7956b724&scoped=true"
import script from "./CompanyNav.vue?vue&type=script&lang=js"
export * from "./CompanyNav.vue?vue&type=script&lang=js"

import "./CompanyNav.vue?vue&type=style&index=0&id=7956b724&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7956b724"]])

export default __exports__